import type { ColumnType } from 'antd/es/table';

/** Sticky ⋮ actions column — wide enough for the header label + row control. */
export const EVIMO_TABLE_ACTIONS_COLUMN_WIDTH = 88;

/**
 * Tighter horizontal padding + nowrap. Always set an explicit `width` / `minWidth`
 * on the column. Prefer {@link EvimoTable} `stickyLastColumn` (or leave `fixed: 'right'`
 * on the last column — EvimoTable converts it) instead of Ant fixed columns for actions.
 */
/** Spread into any column; handlers ignore row type. */
export const evimoTableColFit = {
  onHeaderCell: () => ({ className: 'evimo-table-col-fit' }),
  onCell: () => ({ className: 'evimo-table-col-fit' }),
} satisfies Pick<
  ColumnType<Record<string, unknown>>,
  'onHeaderCell' | 'onCell'
>;

/** Primary text column: single line + native ellipsis when width is set. */
export const evimoTableColPrimary = {
  ellipsis: { showTitle: true },
} satisfies Pick<ColumnType<Record<string, unknown>>, 'ellipsis'>;

/** Last-column row actions (pair with {@link EvimoTable} `stickyLastColumn`). */
export const evimoTableActionsColumn = {
  width: EVIMO_TABLE_ACTIONS_COLUMN_WIDTH,
  minWidth: EVIMO_TABLE_ACTIONS_COLUMN_WIDTH,
  align: 'center' as const,
  ...evimoTableColFit,
} satisfies Pick<
  ColumnType<Record<string, unknown>>,
  'width' | 'minWidth' | 'align' | 'onHeaderCell' | 'onCell'
>;
